module.exports = __webpack_public_path__ + "dingbeauty/admin/img/fbCode_n1.e426b014.png";